import { buildFullPathFromAncestors, getNegativeCondition } from "./helpers";
import { NO_MATCH, POSITIVE_MATCH, NEGATIVE_MATCH, DEFAULT_MATCH } from "./types";

import type { NodeModel } from "@/models/nodes/types";
import type { NodeCondition } from "@corca/data";

export function checkMatchPath(nodeCondition: NodeCondition, node: NodeModel): number {
  if (!nodeCondition.matchPath) {
    return NO_MATCH;
  }

  const fullPath = buildFullPathFromAncestors(node);

  const negativeConditions = nodeCondition.matchPath
    .map((c) => getNegativeCondition(c))
    .filter(Boolean);
  const positiveConditions = nodeCondition.matchPath.filter((c) => !getNegativeCondition(c));

  for (const pathCondition of negativeConditions) {
    const regex = new RegExp(pathCondition);
    if (regex.test(fullPath)) {
      return NEGATIVE_MATCH;
    }
  }

  for (const pathCondition of positiveConditions) {
    const regex = new RegExp(pathCondition);
    if (regex.test(fullPath)) {
      return POSITIVE_MATCH;
    }
  }

  if (positiveConditions.length === 0 && negativeConditions.length > 0) {
    return DEFAULT_MATCH;
  }

  return NO_MATCH;
}
